import createPermission, {any} from 'permissions/createPermission'

export const status = createPermission('unit.devices.walktest.status')
export const run = createPermission('unit.devices.walktest.run')

export default createPermission(any(
    status,
    run,
))